import { useNavigate } from 'react-router-dom';

import { Typography } from '@mui/material';
import { Page } from 'common/components/Page';
import {
    ACL_RESOURCE_USER_LIST_REPORT_SLUG,
    ACL_RESOURCE_USER_LIST_REPORT_TITLE,
    CREATE_REPORT_CAPTION,
    LICENSES_REPORT_SLUG,
    LICENSES_REPORT_TITLE,
    USER_GROUP_ACLS_REPORT_SLUG,
    USER_GROUP_ACLS_REPORT_TITLE,
    USER_GROUPS_REPORT_SLUG,
    USER_GROUPS_REPORT_TITLE,
    USERS_WITH_NEW_ACCESS_REPORT_SLUG,
    USERS_WITH_NEW_ACCESS_REPORT_TITLE } from 'common/constants/reports';
import { Routes, RoutesNameMap } from 'common/constants/routes';

import { SubpageNavButton } from '../../common/components/SubpageNavButton';

export function Reports() {
    const navigate = useNavigate();

    const handleOpenUserGroupsReport = () => {
        navigate(`/${Routes.Reports}/${USER_GROUPS_REPORT_SLUG}`);
    };

    const handleOpenLicensesReport = () => {
        navigate(`/${Routes.Reports}/${LICENSES_REPORT_SLUG}`);
    };

    const handleOpenUserGroupAclsReport = () => {
        navigate(`/${Routes.Reports}/${USER_GROUP_ACLS_REPORT_SLUG}`);
    };

    const handleOpenUsersWithNewAccessReport = () => {
        navigate(`/${Routes.Reports}/${USERS_WITH_NEW_ACCESS_REPORT_SLUG}`);
    };

    const handleOpenAclResourceUserListReport = () => {
        navigate(`/${Routes.Reports}/${ACL_RESOURCE_USER_LIST_REPORT_SLUG}`);
    };

    return (
        <Page
            title={RoutesNameMap.get(Routes.Reports)}
            header={(
                <Typography variant="h5" gutterBottom component="div" marginTop={'1rem'}>
                    {RoutesNameMap.get(Routes.Reports)}
                </Typography>
            )}
        >
            <main style={{ display: 'flex', justifyContent: 'flex-start', gap: '2rem' }}>
                <SubpageNavButton
                    title={USER_GROUPS_REPORT_TITLE}
                    buttonCaption={CREATE_REPORT_CAPTION}
                    onClick={handleOpenUserGroupsReport}
                />
                <SubpageNavButton
                    title={LICENSES_REPORT_TITLE}
                    buttonCaption={CREATE_REPORT_CAPTION}
                    onClick={handleOpenLicensesReport}
                />
                <SubpageNavButton
                    title={USER_GROUP_ACLS_REPORT_TITLE}
                    buttonCaption={CREATE_REPORT_CAPTION}
                    onClick={handleOpenUserGroupAclsReport}
                />
                <SubpageNavButton
                    title={USERS_WITH_NEW_ACCESS_REPORT_TITLE}
                    buttonCaption={CREATE_REPORT_CAPTION}
                    onClick={handleOpenUsersWithNewAccessReport}
                />
                <SubpageNavButton
                    title={ACL_RESOURCE_USER_LIST_REPORT_TITLE}
                    buttonCaption={CREATE_REPORT_CAPTION}
                    onClick={handleOpenAclResourceUserListReport}
                />
            </main>
        </Page>
    );
}
